// extracted by mini-css-extract-plugin
var _1 = "Select-moduleSelect__MROu3";
export { _1 as "Select" }
